import { createFileRoute } from "@tanstack/react-router";
import DashboardProfile from "@/pages/dashboard/Profile";
import ProtectedRoute from "@/components/ProtectedRoute";

export const Route = createFileRoute("/dashboard/profile")({
  component: () => (
    <ProtectedRoute>
      <DashboardProfile />
    </ProtectedRoute>
  ),
});
